<template>
  <transition name="fade">
    <div v-if="visible" ref="dialog" class="dialog" :style="{
      transform: `translate(${position.x}px, ${position.y}px)`,
      width: isMinimized ? '200px' : width + 'px',
      height: isMinimized ? '40px' : height + 'px',
      zIndex: zIndex
    }" draggable="true" @dragstart="startDrag" @dragend="stopDrag">
      <div class="dialog-header">
        <span>{{ title }}</span>
        <div class="header-buttons">

          <el-tooltip class="item" effect="dark" :content="isMinimized ? $t('common.最大化') : $t('common.最小化')"
            placement="top">
            <button class="control-btn" @click="toggleMinimize">
              {{ isMinimized ? '+' : '-' }}
            </button>
          </el-tooltip>


          <el-tooltip class="item" effect="dark" :content="$t('common.关闭')" placement="top">
            <button class="control-btn" @click="close">×</button>
          </el-tooltip>

        </div>
      </div>
      <div class="dialog-content" v-show="!isMinimized" @mousedown="bringToFront">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'DraggableDialog',
  props: {
    title: String,
    visible: Boolean,
    width: { type: Number, default: 370 },
    height: { type: Number, default: 800 },
    initialPosition: {
      type: Object,
      default: () => ({ x: window.innerWidth - 420, y: 50 })
    }
  },
  data() {
    return {
      position: { ...this.initialPosition },
      isMinimized: false,
      // dragStartPos: { x: 0, y: 0 },
      zIndex: 2000
    };
  },
  methods: {
    startDrag(event) {
      this.bringToFront();
      this.dragStartPos = {
        x: event.clientX - event.target.offsetLeft,
        y: event.clientY - event.target.offsetTop
      };
    },
    stopDrag(event) {

      const newX = event.clientX - this.dragStartPos.x;
      const newY = event.clientY - this.dragStartPos.y;
      event.target.style.left = `${newX}px`;
      event.target.style.top = `${newY}px`;
    },
    toggleMinimize() {
      this.isMinimized = !this.isMinimized;
    },
    close() {
      this.$emit('update:visible', false);
    },
    bringToFront() {
      this.zIndex += 1;
    }
  }
};
</script>

<style scoped lang="scss">
.dialog {
  position: absolute;
  background: white;
  left: 0;
  top: 0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  will-change: transform;
  transition:
    width 0.2s ease,
    height 0.2s ease;
}

.dialog-header {
  padding: 8px 16px;
  background: #000000;
  color: white;
  cursor: move;
  user-select: none;
  display: flex;
  justify-content: space-between;
}

.dialog-content {
  padding: 16px;
  height: calc(100% - 72px);
  overflow: auto;
}

.header-buttons {
  display: flex;
  gap: 8px;
}

.control-btn {
  cursor: pointer;
  background: transparent;
  border: none;
  color: white;
  font-size: 14px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  transition: background 0.2s;
}

.control-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>